import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { ScreeningLight, ObjectUpdatePayload, Screening } from 'src/app/models/screeningInvite';
import { UserService } from 'src/app/users-module/services/user.service';
import { UserSetting } from 'src/app/users-module/models/userLight';
import { AuthService } from 'src/app/services/auth.service';
import { Subject, Subscription } from 'rxjs';
import { FilteringService } from 'src/app/services/filtering.service';
import { Router } from '@angular/router';
import {UserSettingsService} from '../../users-module/services/user-settings-service';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-screening-widget',
  templateUrl: './screening-widget.component.html',
  styleUrls: ['./screening-widget.component.less']
})
export class ScreeningWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  ngOnDestroy(): void {
   this.screening.screenings = [];
  }

flipped: boolean = false;
selectAll: boolean = false;
listner$: Subject<any>;
sub: Subscription;

columnsShown : Array<any> = [
  {displayName: 'Report' ,name: "file", shown: true, align: "center"},
  {displayName: 'Name' ,name: "name", shown: true, align: "left"},
  {displayName: 'Status' ,name: "status", shown: true, align: "left"},
  {displayName: 'Ordered' ,name: "orderdate", shown: true, align: "center"},
  {displayName: 'ResidentIQ' ,name: "iq", shown: true, align: "center"},
  // {displayName: 'Contact' ,name: "contact", shown: true},
  // {displayName: 'Rec. Decision' ,name: "recdec", shown: true},
  {displayName: 'Property Decision' ,name: "propertydec", shown: true, align: "left"},
  {displayName: 'Package' ,name: "product", shown: false, align: "left"},
];

  constructor(
    public toast: ToastrService,
    public auth: AuthService,
    public users: UserService,
    public userSettingService: UserSettingsService,
    public screening: ScreeningService,
    public location: Router,
    public filtering : FilteringService,
    public clients : ClientService
  ) {
      // let pagFilter : SimpleDataFilter = new SimpleDataFilter("fetchCount", "10");
      // this.screening.FetchUnFilteredScreeningsList(0,10);
      this.screening.FetchFilteredScreeningsList(10,0);
   }

  ngOnInit() {
    try {

      this.listner$ = this.userSettingService.settingsLoaded;
      this.sub = this.listner$.subscribe((b)=>{
        const screeningSettings = this.userSettingService.userSettings.find(s =>s.settingName === 'ScreeningWidget');
        if(screeningSettings) {
          this.columnsShown = JSON.parse(screeningSettings.settingsJSON);
        }
      },(error)=>{
      });

      this.userSettingService.FetchUserSettings();
    } catch (error) {
    }
  }

  ngAfterViewInit() {
    this.gridTemplateColumns();
  }

  setEditState(s: ScreeningLight){
    s.editing = false;
    s.warned = false;
  }

  savePropertyDecsion(s : ScreeningLight){
    this.screening.GetScreeningById(s.id).subscribe((scc: Screening) =>{
      scc.propertyDecision = s.propertyDecision;
      this.screening.UpdateScreeningPIT(scc).subscribe((rsp : any)=>{
        this.setEditState(s);
        this.toast.success('Property decision set successfully.');
      })
    },(err:any)=>{
      this.toast.error('Error setting property decision.');
    })
    
  }

  checkSettings(){
    if(this.userSettingService.userSettings){
      let screeningSettings = this.userSettingService.userSettings.find(s=>{return s.settingName == "ScreeningWidget"})
      if(screeningSettings){
        this.columnsShown = JSON.parse(screeningSettings.settingsJSON);
      }
    }else{
      this.userSettingService.FetchUserSettings();
    }
  }

  saveSettings(){
    let setting = this.userSettingService.userSettings.find(s=>{return s.settingName == "ScreeningWidget"});
    if(setting){
      setting.settingsJSON = JSON.stringify(this.columnsShown);
      this.userSettingService.SaveUserSetting(setting);
    }else{
      let setting :UserSetting  = new UserSetting();
      setting.settingName = 'ScreeningWidget';
      setting.settingsJSON = JSON.stringify(this.columnsShown);
      setting.userId = this.auth.loggedInUser.id;
      this.userSettingService.SaveUserSetting(setting);
    }
  }

  startNewScreening(){
    this.location.navigateByUrl('/screenings/new')
  }

  toggleAllColumns(){
    this.selectAll = !this.selectAll;
    this.columnsShown.forEach(col => {
      col.shown = this.selectAll;
    });
  }

  columnShown(name : string){
    return this.columnsShown.find(c =>{ return c.name == name }).shown;
  }

  gridTemplateColumns() {
    let colCount = 0;
    this.columnsShown.forEach(colData => {
      if (colData['shown']) {
        colCount += 1;
      }
    });
    return 'repeat(' + colCount + ', auto)';
  }

  toggleColumn(col:string){
    let column = this.columnsShown.find(c =>{ return c.name == col });
    column.shown = !column.shown;
  }
  showSettings(){
    this.flipped = !this.flipped;
  }

  public viewScreening(scrn: ScreeningLight) {
    this.location.navigateByUrl(`screenings/review/${scrn.id}`);
  }

}
